import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { AppConfig, Logger } from 'flux-core';
import { BehaviorSubject } from 'rxjs';

/**
 * This component is used to show the shape thumbanil image
 *
 * @author  gobiga
 * @since   26/07/2017
 */

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'thumbnail-image',
    template: `
        <div class="thumb-img-container fx-center-all" [class.loading]="loading | async">
            <div class="thumb-img-loader-container white">
                <shape-thumbnail-loader></shape-thumbnail-loader>
            </div>
            <div class="thumb-img-image-container fx-center-all" [class.preview]="isPreview" [class.large-preview]="isPreview && hasPreview && previewImage">
                <img #thumbnail [src]="_url" (load)="imageLoaded()" draggable="false" />
            </div>
        </div>`,
    styleUrls: [ './thumbnail-image.scss' ],
})
export class ThumbnailImage {

    /**
     * This property holds the url of the  link thumbnail image
     */
    @Input()
    public url: string;

    @Input()
    public defId: string;

    @Input()
    public version: string;

    public get _url(): string {
        if ( this.isPreview && this.hasPreview && this.previewImage ) {
            return './assets/previews/' + this.previewImage;
        }
        if ( this.url === undefined && this.defId && this.version ) {
            const id = `${this.defId}.${this.version}.svg`;
            return AppConfig.get( 'RESOURCE_LOCATION' ) + 'shape/thumbnails/' + id;
        } else if ( this.url === undefined ) {
            Logger.error( 'ThumbnailImage', `Thumbnail is not found for ${this.defId}.${this.version}.` );
        }
        return this.url;
    }

    /**
     * Preview is used to define a seperate canvas id for RetinaStage.
     */
    @Input() public isPreview: boolean = false;

    @Input() public hasPreview: boolean = false;

    @Input() public previewImage: string = '';

    /**
     * Subject that is used to show and hide the loading indicator.
     */
    public loading: BehaviorSubject<boolean>;

    constructor() {
        this.loading = new BehaviorSubject( true );
    }

    public imageLoaded() {
        // FIXME : 0 Delay is added because without the delay the template is not updating sometimes.
        setTimeout(() => {
            this.loading.next( false );
        }, 0 );
    }
}
